var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_c('span',{attrs:{"contenteditable":""}},[_vm._v("Click here to start editing this text")])])}]

export { render, staticRenderFns }